import DeepSide from './DeepSide';

export default class DeepOutdoorSide extends DeepSide {
  constructor(threekitApi, options = {}) {
    super(threekitApi, options);
    this._key = 'deep_outdoor';
  }
}
